import { fromJS } from 'immutable';

export const GET_WALLET = 'modules/travel-lounge-finder-root/GET_WALLET';
export const SET_WALLET = 'modules/travel-lounge-finder-root/SET_WALLET';

export const getWallet = () => ({
  type: GET_WALLET,
  isLoading: true,
});

export const setWallet = (wallet = []) => ({
  type: SET_WALLET,
  wallet,
});

const initialState = fromJS({
  wallet: [],
  isLoading: false,
});

export const walletReducer = (state = initialState, action = {}) => {
  switch (action?.type) {
    case GET_WALLET:
      return state.set('isLoading', action.isLoading);
    case SET_WALLET:
      return state.set('wallet', action.wallet).set('isLoading', false);
    default:
      return state;
  }
};
